import styled from 'styled-components';
import { brandColors } from 'styles/colors';
import { breakpoint } from 'styles/globals';

const SliderWraper = styled.div`
  margin: auto;

  @media (${breakpoint.xlMin}) {
    max-width: 608px;
  }

  .slick-slider {
    padding: 0 8px;

    .slick-arrow {
      @media (${breakpoint.mdMax}) {
        display: none;
      }
    }
    .arrow-svg {
      width: 18px;
      height: 18px;
    }
    .newsletter {
      margin-top: 12px;

      @media (${breakpoint.mdMin}) {
        margin-top: 14px;
      }
    }
    .slick-dots {
      li {
        width: 10px;
        height: 10px;
        margin: 0 4px;
      }
      li.slick-active button:before {
        color: ${brandColors.crypto.shadeBrandPrimary500};
      }
      li button:before {
        color: ${brandColors.crypto.shadeBrandPrimary200};
        font-size: 10px;
      }
    }

    @media (${breakpoint.mdMin}) {
      padding: 0 16px;
    }
  }
`;

export default SliderWraper;
